// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import vueHeadful from 'vue-headful';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueHtmlToPaper from 'vue-html-to-paper';
import Print from 'vue-print-nb';
import 'es6-promise/auto';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import VModal from 'vue-js-modal';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'babel-polyfill';
import PortalVue from 'portal-vue';
// import VueNativeSock from 'vue-native-websocket';
// import print from 'print-js';

// import spk from 'schemapack';
import App from './App';
import router from './router';
import store from './store/store';

Vue.use(VueAxios, axios);
Vue.use(VueHtmlToPaper);
Vue.use(Print);

Vue.use(ElementUI, { locale });
// Vue.use(ElementUI);
Vue.use(BootstrapVue);
Vue.use(VModal);
Vue.use(PortalVue);
// Vue.use(DisableAutocomplete);
// Vue.use(VueNativeSock, 'wss://ptserv.pt4web.com/wss', { store, format: 'json', connectManually: true });
// Vue.use(VueNativeSock, 'wss://betaserv.pt4web.com/wss', { store, format: 'json', connectManually: true });
// Vue.use(VueNativeSock, 'wss://ptpy.pt4web.com/wsapp', { store, format: 'json', connectManually: true });
Vue.config.productionTip = false;
// eslint-disable-next-line

Vue.component('vue-headful', vueHeadful);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    setInterval(() => {
      store.commit('incTimer');
    }, 100);
  },
  methods: {
    pageChange() {
      this.$store.commit('urlPageChange');
    },
  },
  created() {
    // eslint-disable-next-line
    // alert('Perfect-Teller App started - main - created()');
    window.addEventListener('popstate', this.pageChange, false);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.pageChange);
  },
});



// WEBPACK FOOTER //
// ./src/main.js